import { ToastOpts } from './toasts.types';

export const SHOW_ERROR_TOAST_MESSAGE = '@shared/toast/SHOW_ERROR_TOAST_MESSAGE';
export const SHOW_SUCCESS_TOAST_MESSAGE = '@shared/toast/SHOW_SUCCESS_TOAST_MESSAGE';
export const SHOW_WARNING_TOAST_MESSAGE = '@shared/toast/SHOW_WARNING_TOAST_MESSAGE';

export const showErrorToast = ({
    message, options, component, link,
}: ToastOpts) => ({
    type: SHOW_ERROR_TOAST_MESSAGE,
    payload: {
        message, options, component, link,
    },
});

export const showSuccessToast = ({
    message, options, component, link,
}: ToastOpts) => ({
    type: SHOW_SUCCESS_TOAST_MESSAGE,
    payload: {
        message, options, component, link,
    },
});

export const showWarningToast = ({
    message, options, component, link,
}: ToastOpts) => ({
    type: SHOW_WARNING_TOAST_MESSAGE,
    payload: {
        message, options, component, link,
    },
});
